import { c as _c } from "react/compiler-runtime";
import React, { useState, useRef, useMemo } from 'react';
import cx from 'classnames';
import { format, parse } from 'date-fns';
import PropTypes from 'prop-types';
import Link from 'components/consumer/Link';
import encodeBase64 from 'commons/encodeBase64';
import useScreen from 'hooks/useScreen';
import { colorWhite } from 'styles/layout/colors';
import { isOptionMaterial } from 'commons/constants';
import CtaLink from 'components/essentials/Cta/CtaLink';
import IconCurbSide from 'components/icons/iconCurbSide';
import IconUPSLogo from 'components/icons/iconUPSLogo';
import IconFedexLogo from 'components/icons/iconFedexLogo';
import BrandTooltip from 'components/consumer/BrandTooltip';
import PDPAlertBar from 'components/consumer/PDP/PDPAlertBar';
import { getProductURL } from 'components/consumer/cart/utils';
import IconInHomeDelivery from 'components/icons/iconInHomeDelivery';
import IconMapMarkerWithBase from 'components/icons/IconMapMarkerWithBase';
import ProductImage from 'components/consumer/cart/components/ProductImage';
import ProtectionPlanButtonAndModal from 'components/consumer/ProtectionPlanButtonAndModal';
import FabricAttributeTooltip from 'components/consumer/FabricAdditionalAttributes/FabricAttributeTooltip';
import cleaningCodeDescriptions from 'components/consumer/FabricAdditionalAttributes/cleaning-code-desc.json';
const DisplayOrder = t0 => {
  const $ = _c(79);
  const {
    group,
    id,
    index,
    isDone,
    isImpersonatingUser,
    isLoggedIn,
    isOpenTrackTooltip,
    isShipped,
    noFabrics,
    openTrackingTooltip,
    order,
    selectedCartItemId,
    setSelectedCartItemId,
    setSelectedPPState,
    showSignInPageUponSelection
  } = t0;
  const {
    isMobile
  } = useScreen();
  const orderInfoRef = useRef(null);
  const deliveryInfoRef = useRef(null);
  const trackingInfoRef = useRef(null);
  const [openGloveToolTip, setOpenGloveTooltip] = useState(false);
  const [openCurbsideTooltip, setOpenCurbsideTooltip] = useState(false);
  let deliveredDate = "TBD";
  let t1;
  if ($[0] !== group) {
    t1 = group.some(_temp);
    $[0] = group;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pickLater = t1;
  const estimatedDate = group[0].estimated_delivery || "TBD";
  const estimatedLabel = group[0].estimated_delivery_title;
  if (group[0].delivered_date) {
    ;
    try {
      let t3;
      if ($[2] !== group[0].delivered_date) {
        t3 = format(parse(group[0].delivered_date, "yyyy-MM-dd HH:mm:ss", new Date()), "MMM dd");
        $[2] = group[0].delivered_date;
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      deliveredDate = t3;
    } catch (t2) {
      const e = t2;
    }
  }
  let t2;
  bb0: {
    const deliveredOn = group[0].delivered_date ?? order.delivery_date ?? group[0]?.target_date ?? null;
    if (deliveredOn) {
      let day;
      let month;
      let t3;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        const today = new Date();
        const t4 = String(today.getMonth() + 1);
        let t5;
        if ($[7] !== t4) {
          t5 = t4.padStart(2, "0");
          $[7] = t4;
          $[8] = t5;
        } else {
          t5 = $[8];
        }
        month = t5;
        const t6 = String(today.getDate());
        let t7;
        if ($[9] !== t6) {
          t7 = t6.padStart(2, "0");
          $[9] = t6;
          $[10] = t7;
        } else {
          t7 = $[10];
        }
        day = t7;
        t3 = today.getFullYear();
        $[4] = day;
        $[5] = month;
        $[6] = t3;
      } else {
        day = $[4];
        month = $[5];
        t3 = $[6];
      }
      const year = t3;
      const todaysDate = `${year}-${month}-${day}`;
      let t4;
      if ($[11] !== todaysDate) {
        t4 = new Date(todaysDate).getTime();
        $[11] = todaysDate;
        $[12] = t4;
      } else {
        t4 = $[12];
      }
      let t5;
      if ($[13] !== deliveredOn) {
        t5 = new Date(deliveredOn).getTime();
        $[13] = deliveredOn;
        $[14] = t5;
      } else {
        t5 = $[14];
      }
      t2 = Math.ceil((t4 - t5) / 31557600000);
      break bb0;
    }
    t2 = 0;
  }
  const deliveredYrsBefore = t2;
  let t3;
  if ($[15] !== deliveredDate || $[16] !== estimatedDate || $[17] !== estimatedLabel || $[18] !== group[0].is_delivered || $[19] !== isDone || $[20] !== isShipped || $[21] !== pickLater) {
    t3 = isDone ? group[0].is_delivered === "1" ? <>Delivered on: {deliveredDate}</> : null : !isShipped && estimatedLabel ? <>{estimatedLabel}: {pickLater ? "TBD" : estimatedDate}</> : null;
    $[15] = deliveredDate;
    $[16] = estimatedDate;
    $[17] = estimatedLabel;
    $[18] = group[0].is_delivered;
    $[19] = isDone;
    $[20] = isShipped;
    $[21] = pickLater;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  const deliveryDate = t3;
  const t4 = index + 1;
  let t5;
  if ($[23] !== t4) {
    t5 = <div className="text-base font-bold">Shipment {t4}</div>;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== group[0].delivery_method || $[26] !== openCurbsideTooltip || $[27] !== openGloveToolTip || $[28] !== order.order_status) {
    t6 = order.order_status !== "Canceled" && (group[0].delivery_method === "inhome_delivery" || group[0].delivery_method === "curbside_delivery") ? <>{group[0].delivery_method === "inhome_delivery" ? <div ref={deliveryInfoRef} className="text-sm font-bold pt-[.2rem] text-gray-light2 flex items-center hover:underline [&_span]:px-1 [&_span]:py-0"><IconInHomeDelivery width={18} />{" "}<span role="presentation" onClick={() => setOpenGloveTooltip(!openGloveToolTip)}>In-home delivery</span>{" "}<BrandTooltip title="" parentRef={deliveryInfoRef} isOpenDefault={openGloveToolTip}>Our delivery partners will deliver your order on a pre-scheduled date. The team will move and unpack your order to the room of your choice and dispose of all packaging.</BrandTooltip></div> : null}{group[0].delivery_method === "curbside_delivery" ? <div ref={deliveryInfoRef} className="text-sm font-bold pt-[.2rem] text-gray-light2 flex items-center hover:underline [&_span]:px-1 [&_span]:py-0"><IconCurbSide width={18} />{" "}<span role="presentation" onClick={() => setOpenCurbsideTooltip(!openCurbsideTooltip)}>Curbside Delivery</span>{" "}<BrandTooltip title="" parentRef={deliveryInfoRef} isOpenDefault={openCurbsideTooltip}>Your order will be delivered right to your doorstep or closest entrance, but won’t be unpacked or assembled.</BrandTooltip></div> : null}</> : null;
    $[25] = group[0].delivery_method;
    $[26] = openCurbsideTooltip;
    $[27] = openGloveToolTip;
    $[28] = order.order_status;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] !== t6) {
    t7 = <div>{t6}</div>;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== t5 || $[33] !== t7) {
    t8 = <div className="p-4 flex items-center justify-between bg-gray-light9">{t5}{t7}</div>;
    $[32] = t5;
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  const t9 = !deliveryDate;
  let t10;
  if ($[35] !== t9) {
    t10 = cx("flex items-center justify-between max-[1023px]:flex-col max-[1023px]:items-start", {
      "lg:w-full lg:-left-6": t9
    });
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== deliveryDate) {
    t11 = <div className="text-lg font-bold max-[1023px]:mb-3">{deliveryDate}</div>;
    $[37] = deliveryDate;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== group[0].efg_flag || $[40] !== group[0].tracking_carrier || $[41] !== group[0].tracking_url || $[42] !== isDone || $[43] !== isMobile || $[44] !== isOpenTrackTooltip || $[45] !== openTrackingTooltip || $[46] !== order.order_id || $[47] !== order.order_status || $[48] !== pickLater) {
    t12 = !isDone && !pickLater ? group[0].tracking_url && group[0].tracking_carrier ? <CtaLink className="!p-[0.8rem]" textClassName="!normal-case" size="sm" color="brand" hasArrow={false} styling="solid-button" to={group[0].tracking_url}>{group[0].tracking_carrier?.includes("ups") ? <IconUPSLogo width={28} height={33} /> : group[0].tracking_carrier?.includes("fedex") ? <IconFedexLogo /> : group[0].tracking_carrier}{" "}Tracking</CtaLink> : group[0].efg_flag === "1" ? <div ref={trackingInfoRef} className="text-sm font-bold pt-[.2rem] text-gray-light2 flex items-center hover:underline [&_span]:px-1 [&_span]:py-0"><div role="presentation" onClick={() => openTrackingTooltip(!isOpenTrackTooltip)}>Awaiting Tracking Info</div>{" "}<BrandTooltip title="" parentRef={trackingInfoRef} isOpenDefault={isOpenTrackTooltip}>We are currently awaiting the tracking information from the carrier. Once it has been generated, you’ll see it here. We’ll also send you an email</BrandTooltip></div> : order.order_status ? <CtaLink className="!p-[0.8rem]" textClassName="!normal-case" size="sm" color="brand" hasArrow={false} styling="solid-button" to={`/tracking?order_id=${order.order_id}`}>{isMobile ? <IconMapMarkerWithBase color={colorWhite} /> : null}{"Build updates & tracking"}</CtaLink> : null : null;
    $[39] = group[0].efg_flag;
    $[40] = group[0].tracking_carrier;
    $[41] = group[0].tracking_url;
    $[42] = isDone;
    $[43] = isMobile;
    $[44] = isOpenTrackTooltip;
    $[45] = openTrackingTooltip;
    $[46] = order.order_id;
    $[47] = order.order_status;
    $[48] = pickLater;
    $[49] = t12;
  } else {
    t12 = $[49];
  }
  let t13;
  if ($[50] !== deliveredYrsBefore) {
    t13 = deliveredYrsBefore > 10 && <div className="text-sm font-bold pt-[.2rem] text-gray-light2 flex items-center hover:underline [&_span]:px-1 [&_span]:py-0">Warranty expired</div>;
    $[50] = deliveredYrsBefore;
    $[51] = t13;
  } else {
    t13 = $[51];
  }
  let t14;
  if ($[52] !== t12 || $[53] !== t13) {
    t14 = <div className="order-info__group-tracking">{t12}{t13}</div>;
    $[52] = t12;
    $[53] = t13;
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  let t15;
  if ($[55] !== t10 || $[56] !== t11 || $[57] !== t14) {
    t15 = <div className={t10}>{t11}{t14}</div>;
    $[55] = t10;
    $[56] = t11;
    $[57] = t14;
    $[58] = t15;
  } else {
    t15 = $[58];
  }
  let t16;
  if ($[59] !== noFabrics) {
    t16 = !!noFabrics && <div className="text-base font-bold px-0 py-2.5 text-red">{noFabrics} Thank you for your patience.</div>;
    $[59] = noFabrics;
    $[60] = t16;
  } else {
    t16 = $[60];
  }
  let t17;
  if ($[61] !== group || $[62] !== isImpersonatingUser || $[63] !== isLoggedIn || $[64] !== order.order_id || $[65] !== order.order_status || $[66] !== selectedCartItemId || $[67] !== setSelectedCartItemId || $[68] !== setSelectedPPState || $[69] !== showSignInPageUponSelection) {
    t17 = group.map((item_0, idx) => {
      const productLinkWithOptions = getProductURL({
        productUrlKey: item_0?.url_key,
        options: item_0.options,
        pickLater: item_0.pickLater
      });
      const internalCleaningCode = item_0.group_cleaning_code === "WS" ? "S/W" : item_0.group_cleaning_code;
      return <div key={item_0.id} className="order-info__group-item"><div className={cx({
          "mx-0 my-8 [border-bottom:1px_solid_#f1f1f1]": idx !== 0,
          "m-0 px-0 py-3 [border-bottom:none]": idx === 0
        })} /><div className="flex [&_img]:p-4 [&_img]:rounded [&_img]:bg-gray-light7"><Link className="order-info__product-img" to={productLinkWithOptions}><ProductImage containerClass="order-info__product-img-inner" product={item_0} width={100} trim="color" trimPad={20} /></Link><div className="ml-[.825rem]" data-xc="user-order-shipment-product-details"><Link className="text-base font-bold text-brand no-underline hover:underline" to={productLinkWithOptions}>{item_0.name}</Link><div className="text-xs font-bold text-gray-light2">{`Qty: ${item_0.quantity}`}</div><div className="order-info__product-options">{item_0.options.map(option => <div key={option.id} className="text-xs font-bold text-gray-light2">{item_0.pickLater && isOptionMaterial[option.optionTypeId] ? "Decide Later" : `${option.name} ${option.optionTypeName}`}</div>)}</div>{item_0.group_cleaning_code ? <div className="text-xs font-bold text-gray-light2" ref={orderInfoRef}>{`Cleaning Code: ${item_0.group_cleaning_code}`}{!!cleaningCodeDescriptions[internalCleaningCode] && <span className="mt-0 mx-0 mb-[5px]"><FabricAttributeTooltip title={cleaningCodeDescriptions[internalCleaningCode].title} description={cleaningCodeDescriptions[internalCleaningCode].description} parentRef={orderInfoRef} /></span>}</div> : null}</div></div>{order.order_status !== "Canceled" && order.order_status !== "Replacement" && (item_0.applied_protection_plan || order.order_status !== "Delivered" && item_0.available_protection_plans?.length > 0) && <ProtectionPlanButtonAndModal productId={item_0.product_id} selectedProtectionPlan={item_0.applied_protection_plan} eligible_plans={item_0.available_protection_plans} openModal={() => {
          if (!item_0.applied_protection_plan) {
            setSelectedCartItemId(item_0.cart_id);
          }
        }} isOpen={item_0.cart_id === selectedCartItemId} close={() => {
          setSelectedCartItemId(null);
        }} onSelect={planId => {
          if (!isImpersonatingUser && planId) {
            setSelectedPPState({
              cartItem: item_0,
              orderId: order.order_id,
              selectedPlan: item_0.available_protection_plans.find(p => p.plan_id === planId)
            });
          }
        }} showInactiveProtectionPlan={true} forPage="UserDashboardOrdersPage" showSignInPageUponSelection={showSignInPageUponSelection} />}<div className="order-info__actions-container">{order.order_status === "Delivered" && !item_0.review_exists && <div className="mt-8"><CtaLink color="black" hasArrow={false} styling="solid-button" to={{
              pathname: "/customer/my-reviews",
              state: {
                cart_id: item_0.cart_id,
                product_id: item_0.product_id
              }
            }}>Leave a review</CtaLink><span className="ml-[.825rem] text-gray-light2 text-sm">Get up to $50 in rewards!</span></div>}{item_0.pickLater && <><PDPAlertBar type="info"><strong>Important: </strong> You must select your product customizations before we can start building your furniture!</PDPAlertBar><div className="mt-8"><CtaLink color="black" hasArrow={false} styling="solid-button" to={!isLoggedIn ? "/customer/orders" : isImpersonatingUser ? item_0.url_key : `/edit-order/item/${encodeBase64(item_0.cart_id)}?order_id=${encodeBase64(order.order_id)}`}>Select Customizations</CtaLink></div></>}</div></div>;
    });
    $[61] = group;
    $[62] = isImpersonatingUser;
    $[63] = isLoggedIn;
    $[64] = order.order_id;
    $[65] = order.order_status;
    $[66] = selectedCartItemId;
    $[67] = setSelectedCartItemId;
    $[68] = setSelectedPPState;
    $[69] = showSignInPageUponSelection;
    $[70] = t17;
  } else {
    t17 = $[70];
  }
  let t18;
  if ($[71] !== t15 || $[72] !== t16 || $[73] !== t17) {
    t18 = <div className="p-6 relative" data-xc="user-order-shipment-details">{t15}{t16}{t17}</div>;
    $[71] = t15;
    $[72] = t16;
    $[73] = t17;
    $[74] = t18;
  } else {
    t18 = $[74];
  }
  let t19;
  if ($[75] !== id || $[76] !== t18 || $[77] !== t8) {
    t19 = <div key={id} className="mb-6 bg-white rounded-lg last:mb-0" data-xc="user-order-shipment">{t8}{t18}</div>;
    $[75] = id;
    $[76] = t18;
    $[77] = t8;
    $[78] = t19;
  } else {
    t19 = $[78];
  }
  return t19;
};
DisplayOrder.propTypes = {
  group: PropTypes.object,
  id: PropTypes.string,
  index: PropTypes.number,
  isDone: PropTypes.bool,
  isImpersonatingUser: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isOpenTrackTooltip: PropTypes.bool,
  isShipped: PropTypes.bool,
  noFabrics: PropTypes.object,
  openTrackingTooltip: PropTypes.func,
  order: PropTypes.object,
  selectedCartItemId: PropTypes.string,
  setSelectedCartItemId: PropTypes.func,
  setSelectedPPState: PropTypes.func,
  showSignInPageUponSelection: PropTypes.bool
};
export default DisplayOrder;
function _temp(item) {
  return item.pickLater;
}